export default String.raw`
{{ cart.ThirdPartyHTML }}
<script>{{ cart.ThirdPartyScripts }}</script>
{% if settings.logo_trusted_shop == 'logo_trusted_shop-yes' %}
	<div id="trustedShopsCheckout" style="display: none;">
		<span id="tsCheckoutOrderNr">{{cart.PlacedOrder.Id}}</span>
		<span id="tsCheckoutBuyerEmail">{{cart.Customer.Email}}</span>
		<span id="tsCheckoutOrderAmount">{{cart.OrderTotalValue}}</span>
		<span id="tsCheckoutOrderCurrency">{{cart.Currency}}</span>
		<span id="tsCheckoutOrderPaymentType">OTHER</span>
		{% if cart.SelectedDelivery.SelectedDate -%}
            {% assign tsDeliveryDate = cart.SelectedDelivery.SelectedDate | Date: 'yyyy-MM-dd' -%}
        {% else -%}
            {% assign deliveryDays = cart.SelectedDelivery.Time | ToString | ToTimeSpan -%}
            {% assign tsDeliveryDate = cart.PlacedOrder.Date | Plus: deliveryDays | Date: 'yyyy-MM-dd' -%}
        {% endif -%}
        <span id="tsCheckoutOrderEstDeliveryDate">{{tsDeliveryDate}}</span>
		{% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
		{% for prod in cart.PlacedOrder.Products-%}
            <span class="tsCheckoutProductItem">
                <span class="tsCheckoutProductUrl">{{shopBase}}{{prod.Url}}</span>
                <span class="tsCheckoutProductImageUrl">{% if prod.Image.Id > 0 and prod.Image.Link != null and prod.Image.Link != '' -%}{{shopBase}}img/{{prod.Image.Id}}/{{prod.Image.Link}}{% elsif prod.Image.ExternalUrl != null and prod.Image.ExternalUrl != '' -%}{{prod.Image.ExternalUrl}}{% endif -%}</span>
                <span class="tsCheckoutProductName">{{prod.NameNoHtml}}</span>
                <span class="tsCheckoutProductSKU">{{prod.Code}}</span>
                {% if prod.UPC != null and prod.UPC != '' -%}
                    <span class="tsCheckoutProductGTIN">{{prod.UPC}}</span>
                {% endif -%}
            </span> 
        {% endfor-%}
	</div>
 
	<script>
		(function(){try{trustbadge.reInitialize();}catch(err){}})();
	</script>
{% endif -%}
`